import React from 'react';
import { version } from "../package.json";
import { Loader } from "./components/loader/loader.jsx";
import "./components/pwa/register";
import { config } from "./config.js";
import { i18n } from "./i18n.js";
import { api } from "./lib/api.js";
import { identifyUser, setupIndexedDBErrorHandler } from "./lib/sentry.js";
import { Router } from "./router.jsx";
import { persistor, store } from "./store.jsx";
import i18next from 'i18next';

export const Root = () => {
  const [rehydrated, setRehydrated] = React.useState(false);
  const [languageReady, setLanguageReady] = React.useState(false);

  React.useEffect(() => {
    persistor.subscribe(() => {
      if (!config.tenant) {
        setRehydrated(true);
        return;
      }

      // populate api for future calls
      const state = store.getState();
      api.store = store;
      api.backend_url = config.base_backend_url;
      api.tenant = config.tenant;
      const access_token = api.getToken();

      // set global variable for feature matrix
      const plan = state.persist?.club?.plan || "small";
      window.zweefplan = plan; 

      // if logged in, identify user in sentry
      if (access_token && config.sentry_key) {
        identifyUser(config.sentry_key, state?.persist?.profile?.email);
      }

      console.log(`Welkom bij ${config.tenant} - v${version} - ${plan}`);

      // check initial network status, and update if required
      if (state.flights.network_online !== navigator.onLine) {
        store.dispatch({ type: navigator.onLine ? "ONLINE" : "OFFLINE" });
      }

      // Store translation data for later use
      const translation = state.persist?.club?.translation;

      setRehydrated(true);

      // Initialize i18n with custom translations
      i18n.init(translation).then(() => {
        setLanguageReady(true);
      });
    });

    setupIndexedDBErrorHandler();
  }, []);

  return rehydrated && languageReady ? (
    <Router />
  ) : (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader style={{ margin: "auto" }} />
    </div>
  );
};